/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { MapByRanchId } from 'farmx-web-ui';

export const MapByRanchIdPage = (props) => <MapByRanchId {...props} />;
